import { SxProps } from '@mui/material';

export const geoLocationTriggerSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	color: 'secondary.main',
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline',
	},
	gap: '5px',
};

export const zipCodeFormContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
};

export const zipCodeFormInputSX: SxProps = {
	// Helper text on error
	'& .MuiFormHelperText-root.Mui-error': {
		ml: 0,
	},
	'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.500',
		borderWidth: '1px',
	},
	'& .MuiInputBase-input': {
		color: 'grey.500',
	},
	'& .MuiInputLabel-root': {
		color: 'grey.200',
	},

	'& .MuiInputLabel-root.MuiFormLabel-filled': {
		color: 'grey.200',
	},

	'& .MuiInputLabel-root.Mui-focused:not(.Mui-error)': {
		color: 'grey.200',
	},
	'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.500',
		borderWidth: '1px',
	},
	'& .MuiInputLabel-root.MuiFormLabel-filled + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
		{
			borderColor: 'grey.100',
			borderWidth: '1px',
		},
	'& .MuiInputLabel-root.MuiFormLabel-filled + .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
		{
			borderColor: 'grey.500',
			borderWidth: '1px',
		},
	'& .MuiInputLabel-root.MuiFormLabel-filled + .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':
		{
			borderColor: 'grey.500',
			borderWidth: '1px',
		},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.100',
		borderWidth: '1px',
	},
	'& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, & .MuiInputLabel-root.MuiFormLabel-filled + .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline':
		{
			borderBottom: '2px solid',
			borderColor: 'error.main',
		},
	'& .MuiInputBase-input::placeholder': {
		color: 'grey.100',
		opacity: 1,
	},
};

export const zipCodeFormBtnSX: SxProps = {
	height: 41.56,
};
